import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Update the mobile app settings.
 *
 * @private
 */
export const updateMobileAppInteraction = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.client.rm.MobileAppInteraction,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/updateMobileAppInteraction', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/updateMobileAppInteraction', {
      category: 'rpc',
      type: 'rpc/territory/updateMobileAppInteraction',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateMobileAppInteraction}`,
      { tags: ['rpc', 'territory'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update of mobile app interaction failed`,
      error,
    })
  }
})
